import { ModelSagres } from "../model-sagres"

export class ParticipanteConvenio extends ModelSagres {
    IdParticipanteConvenio: number | null
    IdConvenio: number
    CdCpfCnpjParticipante: string
    NmParticipante: string
    VlParticipacao: number

    toFormData(): FormData {
        const data = new FormData()
        data.append('CdCpfCnpjParticipante', this.CdCpfCnpjParticipante.replaceAll('.','').replaceAll('-','').replaceAll('/',''))
        data.append('NmParticipante', this.NmParticipante.toString())
        data.append('VlParticipacao', this.VlParticipacao.toString())

        return data
    }
}